export default __webpack_public_path__ + "af5d78dcd0783efefe2d678156485d5c.svg";